var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpice = function SvgSpice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: "1rem"
    },
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B75332",
    d: "M465 134.2c21.46-38.38 19.87-87.17-5.65-123.1a23.76 23.76 0 0 0-33.2-5.938c-10.77 7.578-13.44 22.55-5.896 33.41 14.41 20.76 15.13 47.69 4.098 69.77C407.1 100.1 388 95.1 368 95.1c-36.23 0-68.93 13.83-94.24 35.92L352 165.5V256h90.56l33.53 78.23C498.2 308.9 512 276.2 512 239.1c0-41.1-18.3-78.5-47-104.9M320 288V186.6l-52.95-22.69C216.2 241.3 188.5 400 56 400c-30.87 0-56 25.1-56 56s25.13 56 56 56c180.3 0 320.1-88.27 389.3-168.5L421.5 288z"
  })));
};
export { SvgSpice as ReactComponent };
export default "/_next/static/media/static/media/spice.506c5cca6c691dd9871a7d098cb9eaa8svg";